import { gql } from '@apollo/client';

const OrderInfoShared = gql`
  fragment OrderInfoShared on Order {
    id
    state
    paymentState
    paidByPartner
    subscriptionAcknowledgmentEmailSentAt
    renewal
    subscriptionId
    subscription {
      id
      hexCode
      name
    }
    hexCode
    legacyImport
    total
    discountAmount
    taxAmount
    shippingAmount
    toplineRevenue
    earnedRevenue
    partnerRevenueOffice
    partnerRevenuePlatform
    partnerRevenueTotal
    partnerFee
    deliveryMethod
    eotOrder
    courtesyOrder
    sendToClinic
    account {
      id
      accountNumber
    }
    discount {
      id
      code
    }
    referral {
      id
      hexCode
      source
      sentAt
      consumedAt
      createdAt
    }
    user {
      id
      firstName
      lastName
      email
      state
      phone
      hasCognitoSub
    }
    orderItems {
      id
      name
      price
      quantity
      taxAmount
      shippingAmount
      discountAmount
      total
      product {
        id
        name
        featuredImage
        productType
        medicalCode
        medicalDescription
        arches
      }
      patient {
        id
        firstName
        lastName
        arches
        dob
        birthDay
        birthMonth
        birthYear
        scanReady
        scanReadyAt
      }
    }
    partnerLocation {
      id
      name
      address {
        id
        city
        region
      }
    }
    productionOrders {
      id
      hexCode
      state
      createdAt
      productionOrderItems {
        id
        trackingNumber
        shippingCarrier {
          id
          name
        }
      }
    }
    orderTransactions {
      id
      state
      total
      discountAmount
      taxAmount
      shippingAmount
      authcode
      avs
      code
      transactionId
      message
      status
      amountApproved
      createdAt
    }
    createdAt
    updatedAt
    planStartDelay
  }
`;

export default OrderInfoShared;
